// Translator notes: The user's marks applied (engine/src/hints.ts; phase 5 items 11–12).
// Each id is an engine note (`notes.add(text, id, args)`); `args` names its arguments in the order the
// strings take them. Collected by translator/notes.ts (import.meta.glob): adding a note means adding it here.
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  markHints: {
    args: ['n'],
    fi: (a: string[]) => `Käännetty merkintöjen mukaan (${a[0]} ${a[0] === '1' ? 'merkintä' : 'merkintää'} käytetty).`,
    en: (a) => `Translated with the marks (${a[0]} applied).`,
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
